const SET_BOOLEAN_VALUE = "SET_BOOLEAN_VALUE";

export const setBooleanValue = (value) => ({
  type: SET_BOOLEAN_VALUE,
  payload: value,
});

const initialState = {
  value: false,
};

const booleanReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOLEAN_VALUE:
      return {
        ...state,
        value: action.payload,
      };
    default:
      return state;
  }
};

export default booleanReducer;
